import React, { useState } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import styles from "./productfilterbar.module.css";

const ProductFilterBar = () => {
    const [category, setCategory] = useState([]);
    const [price, setPrice] = useState([0, 5000000]);
    const [brand, setBrand] = useState([]);
    const [size, setSize] = useState([]);

    const [showCategory, setShowCategory] = useState(true);
    const [showPrice, setShowPrice] = useState(true);
    const [showBrand, setShowBrand] = useState(true);
    const [showSize, setShowSize] = useState(true);

    const categories = ["Áo sơ mi", "Áo phông", "Quần", "Váy", "Giày"];
    const brands = ["Dior", "Handmade", "Áo sơ mi"];
    const sizes = ["XS", "S", "M", "L", "XL", "XXL", "XXXL"];

    const handleCategoryChange = (event) => {
        const value = event.target.value;
        setCategory(prevState => 
            prevState.includes(value) ? prevState.filter(item => item !== value) : [...prevState, value]
        );
    };

    const handleBrandChange = (event) => {
        const value = event.target.value;
        setBrand(prevState => 
            prevState.includes(value) ? prevState.filter(item => item !== value) : [...prevState, value]
        );
    };

    const handleSizeChange = (event) => {
        const value = event.target.value;
        setSize(prevState => 
            prevState.includes(value) ? prevState.filter(item => item !== value) : [...prevState, value]
        );
    };

    const handlePriceChange = (value) => {
        setPrice(value);
    };

    return (
        <div className={styles.filterBar}>
            <div className={styles.filterSection}>
                <h3 onClick={() => setShowCategory(!showCategory)}>Danh Mục</h3>
                {showCategory && (
                    <div className={styles.filterContent}>
                        {categories.map((cat, index) => (
                            <div key={index}>
                                <input id={`category-${index}`} type="checkbox" class="form-check-input sellerregispageblock2_formCheck__QKHAK" value={cat} onChange={handleCategoryChange} />
                                <label htmlFor={`category-${index}`}>{cat}</label>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <hr></hr>
            <div className={styles.filterSection}>
                <h3 onClick={() => setShowPrice(!showPrice)}>Giá</h3>
                {showPrice && (
                    <div className={styles.filterContent}>
                        <Slider
                            range
                            min={0}
                            max={5000000}
                            step={1000}
                            defaultValue={[0, 5000000]}
                            value={price}
                            onChange={handlePriceChange}
                            trackStyle={[{ backgroundColor: '#e7851a' }]}
                            railStyle={{ backgroundColor: '#000' }}
                        />
                        <span>{price[0]} đ - {price[1]} đ</span>
                    </div>
                )}
            </div>
            <hr></hr>
            <div className={styles.filterSection}>
                <h3 onClick={() => setShowBrand(!showBrand)}>Thương Hiệu</h3>
                {showBrand && (
                    <div className={styles.filterContent}>
                        {brands.map((br, index) => (
                            <div key={index}>
                                <input id={`brand-${index}`} type="checkbox" class="form-check-input sellerregispageblock2_formCheck__QKHAK" value={br} onChange={handleBrandChange} />
                                <label htmlFor={`brand-${index}`}>{br}</label>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <hr></hr>
            <div className={styles.filterSection}>
                <h3 onClick={() => setShowSize(!showSize)}>Kích Thước</h3>
                {showSize && (
                    <div className={styles.filterContent}>
                        {sizes.map((sz, index) => (
                            <div key={index}>
                                <input id={`size-${index}`} type="checkbox" class="form-check-input sellerregispageblock2_formCheck__QKHAK" value={sz} onChange={handleSizeChange} />
                                <label htmlFor={`size-${index}`}>{sz}</label>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <hr></hr>
        </div>
    );
};

export default ProductFilterBar;
